module.exports = __webpack_public_path__ + "img/contact-map.e3781e16.png";